import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

/* This is the custom StimulusReflex controller for the WineManager Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  static targets = ["input", "results", "newForm", "selectedId"];
  static values = {
    selectedId: String,
  };

  connect() {
    StimulusReflex.register(this);
    console.log("OrganizationSearchController connected");
    this.restoreSelectedOrganizationState();
  }

  restoreSelectedOrganizationState() {
    // Restore selected organization state after reload
    if (this.hasSelectedIdTarget && this.selectedIdTarget.value) {
      // If a selection exists, show it in the input and hide the new org form
      this.newFormTarget.classList.add("hidden");
      this.resultsTarget.classList.add("hidden");
    } else if (this.inputTarget.value && this.inputTarget.value.trim() !== "") {
      // If there's an organization name but no selected ID, show the new form
      // This handles the case where the user entered a name but validation failed
      this.newFormTarget.classList.remove("hidden");
      this.resultsTarget.classList.add("hidden");
    } else {
      // No organization name or selection, hide both
      this.newFormTarget.classList.add("hidden");
      this.resultsTarget.classList.add("hidden");
    }
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;

    // Trigger the reflex
    this.stimulate("OrganizationSearch#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    const orgId = event.currentTarget.dataset.orgId;
    const orgName = event.currentTarget.dataset.orgName;

    this.selectedIdValue = orgId;
    this.inputTarget.value = orgName;
    this.resultsTarget.classList.add("hidden");
    this.newFormTarget.classList.add("hidden");

    // Set the organization-id attribute on the element
    this.element.setAttribute("data-organization-id", orgId);

    // Dispatch organization:selected event
    const customEvent = new CustomEvent("organization:selected", {
      detail: { organizationId: orgId, organizationName: orgName },
      bubbles: true,
    });
    this.element.dispatchEvent(customEvent);

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));
  }

  toggleNewForm() {
    // Always hide search results when toggling new form
    this.resultsTarget.classList.add("hidden");

    if (this.selectedIdValue) {
      // Clear selection
      this.selectedIdValue = "";
      this.inputTarget.value = "";
      this.newFormTarget.classList.remove("hidden");
    } else {
      // Toggle new form
      this.newFormTarget.classList.toggle("hidden");
    }
  }

  // Called by the reflex after search
  receiveResults(html) {
    this.resultsTarget.innerHTML = html;
    this.resultsTarget.classList.remove("hidden");
  }
}
